angular.module( 'acme.view.application.layouts.tickets.create.description', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.layouts.tickets.create.description.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var layoutsTicketsCreateDescription = {
        name: 'application.layouts.tickets.create.description',
        url: '/description',
        views: {
          "subview-main": {
            controller: 'LayoutsTicketsCreateDescriptionController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/layouts/tickets/create/description/description.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Ticket Layout'
        }
    },
    layoutsTicketsEditDescription = {
      name: 'application.layouts.tickets.edit.description',
      url: '/description',
      views: {
        "subview-main": {
          controller: 'LayoutsTicketsCreateDescriptionController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/layouts/tickets/create/description/description.tpl.html'
        }
      },
      data: {
        pageTitle: 'Edit Ticket Layout'
      }
    };

    $stateProvider
      .state(layoutsTicketsCreateDescription)
      .state(layoutsTicketsEditDescription);

});
